import React from 'react';
import classes from './PageIndicatorArrow.module.css';

function PageArrow (props) {
  if (props.active || props.idx < props.activePage) {
    return (
      <div className={[classes.PageIndicatorArrow, classes.PageIndicatorArrowActive].join(' ')}>
        <div className={classes.square} />
      </div>
    );
  } else {
    return (
      <div className={[classes.PageIndicatorArrow, classes.PageIndicatorArrowInactive].join(' ')}>
        {props.idx !== props.pageCount && <div className={classes.squareInset} />}
      </div>
    );
  }
}

export default function PageIndicatorArrow (props) {
  let dots = [];
  for (let index = 1; index <= props.pageCount; index++) {
    if (props.activePage === index) {
      dots.push(
        <PageArrow
          activePage={props.activePage}
          pageCount={props.pageCount}
          key={index}
          active idx={index}
        />
      );
    } else {
      dots.push(<PageArrow activePage={props.activePage} pageCount={props.pageCount} key={index} idx={index} />);
    }
  }

  return (
    <div className={classes.PageIndicatorWrapper}>
      {(dots.length > 1) ? dots : null}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/UI/PageIndicatorArrow/PageIndicatorArrow.js